import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed4eace"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "editUser" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Vis/ Rediger mine oplysninger", -1))
const _hoisted_3 = { class: "memberContainer" }
const _hoisted_4 = { class: "layout gutter--lg memberInfoContainer" }
const _hoisted_5 = { class: "row justify--space-around align--center" }
const _hoisted_6 = { class: "flex md8 xs12" }
const _hoisted_7 = { class: "info" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Navn: ")
const _hoisted_9 = { class: "flex md4 xs12" }
const _hoisted_10 = { class: "info" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Licens: ")
const _hoisted_12 = { class: "row justify--space-around align--center" }
const _hoisted_13 = { class: "flex md8 xs12" }
const _hoisted_14 = { class: "info" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Brugernavn: ")
const _hoisted_16 = { class: "flex md4 xs12" }
const _hoisted_17 = { class: "info" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Licens udløber: ")
const _hoisted_19 = { class: "row justify--space-around align--center" }
const _hoisted_20 = { class: "flex md4 xs6" }
const _hoisted_21 = { class: "info" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Født: ")
const _hoisted_23 = { class: "flex md3 xs6" }
const _hoisted_24 = { class: "info" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Køn: ")
const _hoisted_26 = { class: "flex md5 xs12" }
const _hoisted_27 = { class: "info" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Klub: ")
const _hoisted_29 = { class: "row justify--space-around align--center" }
const _hoisted_30 = { class: "flex md3 xs6" }
const _hoisted_31 = { class: "info" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Paradart: ")
const _hoisted_33 = { class: "flex md4 xs12" }
const _hoisted_34 = { class: "info" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Klubrolle: ")
const _hoisted_36 = {
  class: "flex md5",
  style: {"display":"flex"}
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Gem")
const _hoisted_38 = { class: "layout gutter--lg memberInfoContainer mt-4" }
const _hoisted_39 = { class: "row align--center justify--space-around" }
const _hoisted_40 = { class: "flex md6 xs12" }
const _hoisted_41 = { class: "info" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Telefon: ")
const _hoisted_43 = { class: "flex md6 xs12" }
const _hoisted_44 = { class: "info" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Email: ")
const _hoisted_46 = { class: "row align--center justify--space-around" }
const _hoisted_47 = { class: "flex md6 xs12" }
const _hoisted_48 = { class: "info" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode("Vej og husnr.: ")
const _hoisted_50 = { class: "flex md3 xs6" }
const _hoisted_51 = { class: "info" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Postnr.: ")
const _hoisted_53 = { class: "flex md3 xs6" }
const _hoisted_54 = { class: "info" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode("By: ")
const _hoisted_56 = { class: "row justify--center align--center" }
const _hoisted_57 = { class: "flex md6 xs12 center" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode("Se min historik")
const _hoisted_59 = { class: "flex md6 xs12 center" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode("Rediger mine oplysninger")
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Anmod om klubskifte", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info center mb-2" }, "Jeg vil gerne anmode om at skifte til:", -1))
const _hoisted_63 = { class: "row justify--center" }
const _hoisted_64 = { class: "flex" }
const _hoisted_65 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex md6 center" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Skift til")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex md4 center" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Status")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "flex md2" })
], -1))
const _hoisted_67 = { class: "flex md6 center" }
const _hoisted_68 = { class: "flex md4 center" }
const _hoisted_69 = { class: "flex md2" }
const _hoisted_70 = { class: "row justify--center" }
const _hoisted_71 = { class: "flex" }
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Skift klub")
const _hoisted_73 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Ændre mine kontaktoplysninger", -1))
const _hoisted_75 = { class: "layout gutter--xl" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "flex md6" }
const _hoisted_78 = { class: "flex md6" }
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "flex md12" }
const _hoisted_81 = { class: "row" }
const _hoisted_82 = { class: "flex md6" }
const _hoisted_83 = { class: "flex md6" }
const _hoisted_84 = { class: "row justify--center" }
const _hoisted_85 = { class: "flex" }
const _hoisted_86 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_87 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "display-4 center" }, "Min historik", -1))
const _hoisted_89 = { class: "va-table-responsive myHistory" }
const _hoisted_90 = {
  class: "va-table va-table--hoverable",
  style: {"width":"100%"}
}
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Dato"),
    /*#__PURE__*/_createElementVNode("th", null, "Begivenhed")
  ])
], -1))
const _hoisted_92 = {
  key: 0,
  class: "row justify--center mt-4"
}
const _hoisted_93 = { class: "flex" }
const _hoisted_94 = { class: "row justify--center" }
const _hoisted_95 = { class: "flex" }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Luk")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_form = _resolveComponent("va-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.firstName + ' ' + _ctx.memberData.lastName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.licenseNumber === null ? '0' : _ctx.memberData.licenseNumber), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("p", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.userName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("strong", null, _toDisplayString(_ctx.expirationDate(_ctx.memberData.licenseExpires)), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("p", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("strong", null, _toDisplayString(_ctx.toDanishDateString(_ctx.memberData.birthDate)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.gender), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("p", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.clubName), 1),
              _createVNode(_component_va_popover, {
                message: "Anmod om klubskifte",
                style: {"float":"right"},
                placement: "right"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_va_icon, {
                    name: "edit",
                    class: "changeClubButton",
                    style: {"float":"right"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeClub()))
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("p", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("strong", null, _toDisplayString((_ctx.memberData.paraDartPlayer ? 'Ja' : 'Nej')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("p", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.clubRole), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_va_select, {
              class: "center",
              modelValue: _ctx.sharePermissionsValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sharePermissionsValue) = $event)),
              options: _ctx.sharePermissionsOptions,
              label: "Del oplysninger m. holdkaptajn"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "success",
              size: "small",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePermissions()))
            }, {
              default: _withCtx(() => [
                _hoisted_37
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("p", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.telephone), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("p", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.email), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("p", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.address), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("p", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.postalNumber), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("p", _hoisted_54, [
              _hoisted_55,
              _createElementVNode("strong", null, _toDisplayString(_ctx.memberData.city), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_va_button, { onClick: _ctx.seeHistory }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  name: "manage_search",
                  class: "mr-2"
                }),
                _hoisted_58
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_va_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeContactInformationModal = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, {
                  name: "edit",
                  class: "mr-2"
                }),
                _hoisted_60
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.changeClubModal,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.changeClubModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_61
      ]),
      body: _withCtx(() => [
        _hoisted_62,
        _createElementVNode("div", _hoisted_63, [
          _createElementVNode("div", _hoisted_64, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.changeClubValue,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.changeClubValue) = $event)),
              options: _ctx.changeClubOptions,
              searchable: "",
              bordered: "",
              "text-by": "name",
              "track-by": "id"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        (_ctx.requestInProgress.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
              _hoisted_66,
              _createVNode(_component_va_divider),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.requestInProgress, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id,
                  class: "row clubChangeList align--center justify--space-around"
                }, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("p", null, _toDisplayString(item.klubskifte_nyklub.klubber_klubnavn), 1)
                  ]),
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("p", null, _toDisplayString(item.klubskifte_god_afv), 1)
                  ]),
                  _createElementVNode("div", _hoisted_69, [
                    _createVNode(_component_va_popover, { message: "Fortryd anmodning" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          name: "delete_forever",
                          class: "hoverEffect",
                          color: "danger",
                          onClick: ($event: any) => (_ctx.cancelRequest(item.id))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_70, [
          _createElementVNode("div", _hoisted_71, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.requestClubChange())),
              disabled: _ctx.changeClubValue.id === 0 || this.memberData.clubID === _ctx.changeClubValue.id
            }, {
              default: _withCtx(() => [
                _hoisted_72
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeClubModal=false))
            }, {
              default: _withCtx(() => [
                _hoisted_73
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.changeContactInformationModal,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.changeContactInformationModal) = $event)),
      "closable-mask": false
    }, {
      header: _withCtx(() => [
        _hoisted_74
      ]),
      body: _withCtx(() => [
        _createVNode(_component_va_form, { ref: "updateMemberForm" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("div", _hoisted_76, [
                _createElementVNode("div", _hoisted_77, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.memberData.telephone,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.memberData.telephone) = $event)),
                    label: "Telefon",
                    bordered: "",
                    rules: [(v) => (v.length === 8 && !isNaN(v)) || 'Vi skal bruge et telefonnummer' ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_78, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.memberData.email,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.memberData.email) = $event)),
                    label: "Email",
                    bordered: "",
                    rules: [(v) => _ctx.checkEmail(v) || 'Angiv venligst en korrekt email adresse' ]
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.memberData.address,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.memberData.address) = $event)),
                    label: "Adresse",
                    bordered: "",
                    rules: [(v) => v.length > 1 || 'Angiv en adresse']
                  }, null, 8, ["modelValue", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_81, [
                _createElementVNode("div", _hoisted_82, [
                  _createVNode(_component_va_input, {
                    type: "number",
                    modelValue: _ctx.memberData.postalNumber,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.memberData.postalNumber) = $event)),
                    label: "Post nr.",
                    bordered: "",
                    rules: [(v) => v.length === 4 || 'Postnr. mangler' ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_83, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.memberData.city,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.memberData.city) = $event)),
                    label: "By",
                    bordered: "",
                    rules: [(v) => v.length > 1 || 'By mangler']
                  }, null, 8, ["modelValue", "rules"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              color: "success",
              onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$refs.updateMemberForm.validate();_ctx.updateContactInformation()})
            }, {
              default: _withCtx(() => [
                _hoisted_86
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "ml-4",
              color: "secondary",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.changeContactInformationModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_87
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.seeHistoryModal,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.seeHistoryModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_88
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("table", _hoisted_90, [
            _hoisted_91,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.memberHistory, (member) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: member.id
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("i", null, _toDisplayString(_ctx.toDanishDateString(member.created_at)), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(member.medlemshistorik_handling), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        (_ctx.memberHistory.length >= 10)
          ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
              _createElementVNode("div", _hoisted_93, [
                _createElementVNode("p", {
                  class: "sorting showMore",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => {_ctx.showCompleteHistory = !_ctx.showCompleteHistory; _ctx.retrieveMemberHistory()})
                }, _toDisplayString((_ctx.showCompleteHistory ? 'Vis færre' : 'Vis flere')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createVNode(_component_va_button, {
              color: "secondary",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.seeHistoryModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_96
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}